import React, { useState, useEffect } from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import { AiFillStar } from 'react-icons/ai';
import { MdClose, MdLocationOn, MdEmail, MdPhone, MdAccessTime, MdHome, MdMap, MdBusiness } from 'react-icons/md';
import OfferCard from './OfferCard';
import '../../components/Styles/ClientPage.css';

const HeroSection = ({ toggleModal, venueDetails }) => {
  const images = venueDetails?.responseContent?.venueDetails[0]?.images || [];
  const turfDetails = venueDetails?.responseContent?.venueDetails[0] || {};

  const {
    turf_name = 'Cine Field',
    locality = 'Pallavaram',
    district_name = 'Chengalpattu',
    turf_address = '',
    city = '',
    state = '',
    pincode = '',
    phone_number = '',
    email_id = '',
    business_days = '',
    business_hours = '',
    other_details = ''
  } = turfDetails;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoPlay] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal-backdrop")) {
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    const nextSlide = () => {
      if (images.length > 0) {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }
    };

    let interval;
    if (autoPlay && images.length > 0) {
      interval = setInterval(nextSlide, 5000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [currentIndex, autoPlay, images.length]);

  return (
    <div className="hero-section">
      {images.length > 0 && (
        <div
          className="hero-section__background"
          style={{
            backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.6), transparent), url(${images[currentIndex]})`,
          }}
        ></div>
      )}

      {images.length > 0 && (
        <div className="hero-section__poster">
          <div className="relative w-full h-full bg-gray-300 opacity-90 rounded-lg">
            <img
              src={images[currentIndex]}
              alt="Venue"
              className="hero-section__poster-image"
            />
            <div className="absolute inset-0 flex flex-col justify-end p-3 text-white">
              <h3 className="text-lg font-bold flex items-center text-transparent bg-clip-text bg-gradient-to-r from-purple-900 to-blue-900">
                {turf_name}
                <BsInfoCircle
                  className="ml-2 cursor-pointer text-sm text-black"
                  onClick={handleToggleModal}
                />
              </h3>
              <p className="text-xs">
                {locality}, {district_name}
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="hero-section__info">
        <h2 className="hero-section__info-title">
          {turf_name}
          <BsInfoCircle
            className="ml-2 cursor-pointer text-lg text-black"
            onClick={handleToggleModal}
          />
        </h2>
        <p>
          {locality}, {district_name}
        </p>
        <div className="hero-section__stars">
          {[1, 2, 3, 4, 5].map((_, index) => (
            <AiFillStar key={index} className="text-yellow-400 text-xl" />
          ))}
        </div>
      </div>

      <div
        className="hero-section__arrow hero-section__arrow--left"
        onClick={() => setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1))}
      >
        &#8249;
      </div>
      <div
        className="hero-section__arrow hero-section__arrow--right"
        onClick={() => setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)}
      >
        &#8250;
      </div>

      <OfferCard />

      <div className="hero-section__dots">
        {images.map((_, index) => (
          <div
            key={index}
            className={`hero-section__dot ${currentIndex === index ? 'hero-section__dot--active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></div>
        ))}
      </div>

      {isModalOpen && (
        <div className="modal-backdrop" onClick={handleOutsideClick}>
          <div className="modal-container p-4 rounded-lg bg-gradient-to-br from-white to-gray-100 shadow-lg max-w-lg mx-auto">
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              onClick={handleToggleModal}
            >
              <MdClose className="text-xl" />
            </button>
            
            <h2 className="text-2xl font-bold text-gray-800 mb-2">{turf_name}</h2>
            <hr className="border-t border-gray-300 mb-2" />

            <div className="mb-2 bg-gray-50 p-3 rounded-lg shadow-sm">
              <h3 className="text-lg font-semibold text-gray-700">Contact</h3>
              <p className="flex items-center text-sm text-gray-600">
                <MdPhone className="mr-2" /> {phone_number || 'Not Available'}
              </p>
              <p className="flex items-center text-sm text-gray-600">
                <MdEmail className="mr-2" /> {email_id || 'Not Available'}
              </p>
            </div>
            
            <hr className="border-t border-gray-200 my-2" />

            <div className="mb-2 bg-gray-50 p-3 rounded-lg shadow-sm">
              <h3 className="text-lg font-semibold text-gray-700">Location</h3>
              <p className="text-sm text-gray-600">{turf_address}</p>
              <p className="text-sm text-gray-600">{locality}, {city}, {state} - {pincode}</p>
            </div>

            <hr className="border-t border-gray-200 my-2" />
            
            <div className="mb-2 bg-gray-50 p-3 rounded-lg shadow-sm">
              <h3 className="text-lg font-semibold text-gray-700">Operating Hours</h3>
              <p className="flex items-center text-sm text-gray-600">
                <MdAccessTime className="mr-2" /> Days: {business_days || 'Not Available'}
              </p>
              <p className="flex items-center text-sm text-gray-600">
                <MdAccessTime className="mr-2" /> Hours: {business_hours || 'Not Available'}
              </p>
            </div>

            <hr className="border-t border-gray-200 my-2" />
            
            <div className="flex justify-center mt-2">
              <button
                className="px-5 py-1 bg-blue-600 text-white font-semibold rounded-full hover:bg-blue-700 transition"
                onClick={handleToggleModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeroSection;
